import React from 'react';
import EarthImg from '../images/earth.webp'
import { Helmet } from 'react-helmet-async';

function Geography() {
  return (
    <div className="xContent p-0">
          <Helmet>
        <title>География</title>
        <meta
        name="description"
        content="География Ассоциации Некоммерческого Партнерства 
        «Международная Ассоциация Маркетологов СНГ»"
        />
        <link rel="canonical" href="https://marketing-association.com/geography"/>
      </Helmet>
        <div class="block">
    <div class="image is-3by1 is-bgcover"><img src={EarthImg} alt="Earth" /></div>
</div>
        <div class="title is-font-title-regular has-text-centered has-text-var-blue">География Международной Ассоциации Маркетологов</div>
        <div class="block has-text-centered has-text-var-blue is-font-title-regular">Всего членов: <span class="is-size-4">406</span></div>
        <div class="block my-6">
    <div class="columns is-flex-wrap-wrap">
                    <div class="column">
                <div class="xCounter">
                    <div class="xCounterVal">120</div>
                    <div class="xCounterVar">Россия</div>
                </div>
            </div>
                    <div class="column">
                <div class="xCounter">
                    <div class="xCounterVal">83</div>
                    <div class="xCounterVar">Украины</div>
                </div>
            </div>
                                <div class="column">
                <div class="xCounter">
                    <div class="xCounterVal">65</div>
                    <div class="xCounterVar">Армения</div>
                </div>
            </div>

            </div>
        </div>
    <div class="block my-6">
    <div class="columns is-flex-wrap-wrap">
                     <div class="column">
                <div class="xCounter">
                    <div class="xCounterVal">28</div>
                    <div class="xCounterVar">Беларусия</div>
                </div>
            </div>       
                    <div class="column">
                <div class="xCounter">
                    <div class="xCounterVal">27</div>
                    <div class="xCounterVar">Азербайджан</div>
                </div>
            </div>
                    <div class="column">
                <div class="xCounter">
                    <div class="xCounterVal">17</div>
                    <div class="xCounterVar">Молдавия</div>
                </div>
            </div>

            </div>
        </div>
        <div class="block my-6">
    <div class="columns is-flex-wrap-wrap">
                    <div class="column">
                <div class="xCounter">
                    <div class="xCounterVal">16</div>
                    <div class="xCounterVar">Казахстан</div>
                </div>
            </div>
                    <div class="column">
                <div class="xCounter">
                    <div class="xCounterVal">13</div>
                    <div class="xCounterVar">Таджикистан</div>
                </div>
            </div>
                                <div class="column">
                <div class="xCounter">
                    <div class="xCounterVal">11</div>
                    <div class="xCounterVar">Грузия</div>
                </div>
            </div>

            </div>
        </div>
        <div class="block my-6">
    <div class="columns is-flex-wrap-wrap">
                    <div class="column">
                <div class="xCounter">
                    <div class="xCounterVal">11</div>
                    <div class="xCounterVar">Грузия</div>
                </div>
            </div>
                    <div class="column">
                <div class="xCounter">
                    <div class="xCounterVal">5</div>
                    <div class="xCounterVar">Узбекистан</div>
                </div>
            </div>   
                    <div class="column">
                <div class="xCounter">
                    <div class="xCounterVal">3</div>
                    <div class="xCounterVar">Латвия</div>
                </div>
            </div>                      
            </div>
        </div>
                <div class="block my-6">
    <div class="columns is-flex-wrap-wrap">
                    <div class="column">
                <div class="xCounter">
                    <div class="xCounterVal">3</div>
                    <div class="xCounterVar">Литва</div>
                </div>
            </div>
                    <div class="column">
                <div class="xCounter">
                    <div class="xCounterVal">2</div>
                    <div class="xCounterVar">Эстония</div>
                </div>
            </div>   
                    <div class="column">
                <div class="xCounter">
                    <div class="xCounterVal">2</div>
                    <div class="xCounterVar">Туркменистан</div>
                </div>
            </div>                      
            </div>
        </div>
    </div>
  );
}

export default Geography;
